import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a1d420e9ad5300144ad708/elevatesupport/src/app/knowledge-performance/components/KnowledgePerformanceInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a1d420e9ad5300144ad708/elevatesupport/src/components/common/Header.tsx");
